module.exports = __webpack_public_path__ + "img/today_customer.68d410b5.png";